export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14384.1d7339a1.jpg";